import axios from 'axios';

/**
 * Création de l'instance Axios
 * La baseURL est choisie dynamiquement selon le fichier .env chargé
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- INTERCEPTEUR DE REQUÊTE ---
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- INTERCEPTEUR DE RÉPONSE ---
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Cas 1 : Erreur 401 (Non autorisé / Token expiré)
    if (error.response && error.response.status === 401) {
      
      // LOGIQUE DE PROTECTION : On ne déconnecte pas si c'est une erreur de mot de passe
      // ou si on est déjà sur la page de login
      const url = error.config.url;
      const isUpdateProfile = url.includes('/update-profile');
      const isLogin = url.includes('/login');

      if (!isUpdateProfile && !isLogin) {
        console.warn("Session expirée. Redirection...");
        
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('adminActiveTab'); // Optionnel
        
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      } else {
        console.log("Erreur 401 ignorée par l'intercepteur (tentative de connexion ou profil)");
      }
    }

    // Cas 2 : Salon suspendu
    if (error.response && error.response.status === 403 && error.response.data?.salonSuspended) {
      window.dispatchEvent(new CustomEvent('salon-suspended', {
        detail: { message: error.response.data.message }
      }));
    }

    // Cas 3 : Erreur réseau
    if (!error.response) {
      console.error("Erreur réseau : Vérifiez que le Backend est lancé.");
    }

    return Promise.reject(error);
  }
);

export default api;